import { z } from 'zod'
import { oc } from '@orpc/contract'

/**
 * /v2/auth change-password (PD-1629, My Profile's Security tab). Authenticated: the
 * caller's own bearer is forwarded to Medplum, which checks the current password itself.
 * A refusal is a BAD_REQUEST whose `data.field` names the field it belongs to
 * (`currentPassword` or `newPassword`) and whose message is what the field shows.
 */
export const authChangePasswordInputSchema = z.object({
  currentPassword: z.string().min(1),
  newPassword: z.string().min(8, 'Must be at least 8 characters'),
})
export type ChangePasswordField = keyof z.infer<typeof authChangePasswordInputSchema>

export const authChangePassword = oc
  .route({ method: 'POST', path: '/v2/auth/change-password' })
  .input(authChangePasswordInputSchema)
  .output(z.object({ ok: z.literal(true) }))
